<!--  -->
<template>
  <div class="LungCancer">
    <div class="LungCancer-main">
      <div class="shuju">
        <div class="shuju-text">
          <h1>肺癌，癌症之王</h1>
          <p>国家癌症中心2019年全国癌症统计数据:</p>
          <p>
            新增肺癌患者<span>78.7</span>万，占恶性肿瘤发病人群<span
              >20.03%</span
            >
          </p>
          <p>
            肺癌患者死亡<span>63.1</span>万，占恶性肿瘤死亡人群<span
              >26.99%</span
            >
          </p>
        </div>
        <div class="feiai1">
          <img src="../../assets/feiai1.png" />
        </div>
      </div>
      <div class="zhuzhuangtu">
        <div class="zhuzhuangtu-img">
          <img src="../../assets/feiai2.png" />
          <p>2015年恶性肿瘤死亡前十位</p>
        </div>
        <div class="zhuzhuangtu-img">
          <img src="../../assets/feiai2.png" />
          <p>2015年恶性肿瘤死亡前十位</p>
        </div>
      </div>

      <div class="survival">
        <h1>早诊断 早治疗 提高肺癌生存率</h1>
        <div class="survival-box">
          <div class="survival-img">
            <img src="../../assets/feiai3.png" />
          </div>
          <div class="survival-msg" v-html="msg"></div>
        </div>
      </div>
    </div>
    <div class="screening">
      <div class="screening-main">
        <h1>肺癌早期筛查针对人群：</h1>
        <div class="screening-box">
          <div class="screening-msg" v-html="screeningMsg"></div>
          <div class="screening-img">
            <img src="../../assets/screening.png" />
          </div>
        </div>
      </div>
    </div>

    <div class="inquiry-mode">
      <h1>肺癌筛查方式——导航支气管镜活检</h1>
      <p>
        支气管镜检查是将内窥镜经口腔或鼻腔插入到气管、支气管内进行的检查。可到达肺部中心的气管和附近的肺叶、肺段支气管。随着现代医学技术的发展，支气管镜检查并不像人们想象中那么难受。目前使用的支气管镜由柔软可弯曲的材料制成，滴入麻药，可以让反射性呛咳、气管痉挛等不适消失。
      </p>
      <h2>导航支气管镜技术</h2>
      <p>
        绝大部分中央型病灶可以通过常规支气管镜检查得到确认，但对于周围性病灶和周围性气道外病灶，支气管镜无法准确到达，而经皮肺穿刺取样等技术并发症多、风险较高。
      </p>
      <div class="inquiry-img">
        <div class="inquiry-box">
          <img src="../../assets/BTPNA.png" />
          <p>*BTPNA演示</p>
        </div>
        <div class="inquiry-box">
          <img src="../../assets/tongb.png" />
          <p>*导航：实时镜下图像与虚拟图像同步</p>
        </div>
      </div>
      <h2>通过导航技术引导的支气管镜操作，可以实现以下目的：</h2>
      <p>
        对于气道内病灶，引导支气管镜准确、快速到达，进行后续临床诊疗工作；对于外周气道外病灶，BTPNA技术建立直达病灶隧道实现抵达，对比其他方法更加安全有效。
      </p>
      <p>*导航支气管镜手术术后无需特殊护理。</p>
    </div>

    <div class="therapy-method">
      <h1>肺癌治疗方式——RF射频消融</h1>
      <div class="method-main">
        <div class="method-msg" v-html="methodMsg"></div>
        <div class="method-img">
          <img src="../../assets/zhiliaofangfa.png" />
          <div class="method-jiantou">
            <img src="../../assets/zhiliaojiantou.png" />
            <img src="../../assets/zhiliaojiantou.png" />
            <img src="../../assets/zhiliaojiantou.png" />
          </div>
          <img src="../../assets/zhiliaofangfa.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      msg: `<p>目前，肺癌患者的5年生存率仅为 15.6%
早期肺癌的五年生存率6倍于晚期肺癌</p>`,
      screeningMsg: ``,
      methodMsg: ``,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.LungCancer {
  width: 100%;
  .LungCancer-main {
    width: $main-width;
    margin: 0 auto;
    .shuju {
      display: flex;
      justify-content: space-between;
      .shuju-text {
        width: 45%;
        h1 {
          text-align: center;
          color: #8553a2;
          font-size: 1.4rem;
        }
        p {
          width: 100%;
          font-size: 1.1rem;
          color: #666;
          text-align: center;
          letter-spacing: 2px;
          span {
            font-size: 1.5rem;
            color: #f8ad17;
          }
        }
        p:nth-child(2) {
          margin-top: 30px;
        }
        p:nth-child(3) {
          margin-top: 5px;
        }
      }
    }
    .zhuzhuangtu {
      margin-top: 60px;
      display: flex;
      justify-content: space-between;
      .zhuzhuangtu-img {
        p {
          font-size: 0.9rem;
          color: #666;
          text-align: center;
          padding: 25px 0;
        }
      }
    }
    .survival {
      margin-top: 70px;
      h1 {
        text-align: center;
        font-size: 1.4rem;
        color: #8553a2;
      }
      .survival-box {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        .survival-img {
          padding: 20px;
        }
      }
    }
  }
  .screening {
    width: 100%;
    margin: 0 auto;
    height: 576px;
    background: #47aeea;
    .screening-main {
      width: $main-width;
      margin: 0 auto;
      margin-top: 60px;
      padding-top: 60px;
      h1 {
        text-align: center;
        font-size: 1.4rem;
        color: #fff;
        font-weight: bold;
        letter-spacing: 2px;
      }
      .screening-box {
        display: flex;
        justify-content: space-around;
        margin-top: 50px;
        .screening-msg {
          width: 40%;
          color: #fff;
        }
      }
    }
  }

  .inquiry-mode {
    width: $main-width;
    margin: 80px auto;
    h1 {
      text-align: center;
      font-size: 1.4rem;
      color: #8553a2;
      font-weight: bold;
      margin-bottom: 40px;
    }
    h2 {
      margin: 30px 0 20px;
      color: #0a7ec1;
      font-size: 1.2rem;
    }
    p {
      font-size: 1rem;
      color: #333;
      line-height: 1.5;
    }
    .inquiry-img {
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      p {
        font-size: 0.8rem;
        text-align: center;
        padding: 10px 0;
        color: #333;
      }
    }
  }

  .therapy-method {
    width: $main-width;
    margin: 0 auto 120px;
    h1 {
      color: #8553a2;
      text-align: center;
      font-size: 1.4rem;
      font-weight: bold;
    }
    .method-main {
      display: flex;
      margin-top: 50px;
      justify-content: space-between;
      .method-img {
        display: flex;
        justify-content: space-around;
        .method-jiantou {
          height: 100%;
          padding: 0 10px;
          display: flex;
          flex-direction:column;
            img:nth-child(1) {
                margin-top: 50px;
            }
            img {
                margin-top: 10px;
            }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/LungCancer1.vue